const state = {
  unitData: localStorage.getItem('unitData') ? JSON.parse(localStorage.getItem('unitData')) : ''
}

const mutations = {
  // reset all
  SMART_TEACHING_SYSTEM_RESET_ALL(state, data) {
    const remove = ['unitData']
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },
  // unitData
  SMART_TEACHING_SYSTEM_UNIT_DATA(state, data) {
    state.unitData = data
    data === '' ? localStorage.removeItem('unitData') : localStorage.setItem('unitData', JSON.stringify(data))
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_RESET_ALL', '')
      resolve()
    })
  },
  // 设置选中单元
  setUnitData({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_UNIT_DATA', data)
      resolve(data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
